<template>
  <div class="avatar" :style="{ backgroundColor: `#${backgroundColor}`, '--size': `${size}px`, '--font-size': `${fontSize}rem` }">
    <span :style="{ color: textColor }">{{ initials }}</span>
  </div>
</template>

<script>
export default {
  name: 'Avatar',
  props: {
    name: String,
    size: {
      type: Number,
      default: 45
    },
    fontSize: {
      type: Number,
      default: 1
    },
  },
  data: function () {
    return {};
  },
  computed: {
    initials: function () {
      let initials = this.name.match(/\b\w/g) || [];
      return ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
    },
    backgroundColor: function () {
      let hash = 0;
      for (let i = 0; i < this.name.length; i++) {
        hash = this.name.charCodeAt(i) + ((hash << 5) - hash);
      }
      let c = (hash & 0x00FFFFFF)
        .toString(16)
        .toUpperCase();

      return "00000".substring(0, 6 - c.length) + c;
    },
    textColor: function () {
      let rgb = parseInt(this.backgroundColor, 16);   // convert rrggbb to decimal
      let r = (rgb >> 16) & 0xff;  // extract red
      let g = (rgb >>  8) & 0xff;  // extract green
      let b = (rgb >>  0) & 0xff;  // extract blue

      let luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709

      if (luma > 128) {
        return 'black';
      }
      else {
        return 'white';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
div.avatar {
  width: var(--size);
  height: var(--size);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;

  span {
    line-height: 1;
    font-size: var(--font-size);
    font-weight: 500;
  }
}
</style>
